var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAk15543430(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145.4 30",
    style: {
      enableBackground: "new 0 0 145.4 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: -6.7,
    transform: "matrix(0.4704 -0.8824 0.8824 0.4704 0.5132 15.9926)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.4,
    y: 20.8,
    transform: "matrix(0.8672 -0.498 0.498 0.8672 -8.7991 9.7026)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.7,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1,30H0V0h30.1V30z M1.2,28.8H29V1.2H1.2V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7,25.9H4V3.7h22.8V25.9z M5.1,24.8h20.5v-20H5.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.6,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 11.9382 62.902)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 47.5852 124.8605)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.1,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,30h-30.1V0h30.1V30z M116.4,28.8h27.8V1.2h-27.8V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.4,25.9h-22.8V3.7h22.8V25.9z M119.8,24.8h20.5v-20h-20.5V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.9,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 8.5631 49.3981)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 33.1658 99.9612)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,30H86.5V0h30.1V30z M87.7,28.8h27.8V1.2H87.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7,25.9H90V3.7h22.8V25.9z M91.1,24.8h20.5v-20H91.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.9,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 5.154 35.7587)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.3,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 18.6066 74.8211)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.4,
    y: 11,
    width: 3.6,
    height: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.7,30H57.6V0h30.1V30z M58.7,28.8h27.8V1.2H58.7V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,25.9H61V3.7h22.8V25.9z M62.1,24.8h20.5v-20H62.1V24.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 7,
    transform: "matrix(0.8824 -0.4705 0.4705 0.8824 1.7789 22.2548)",
    width: 28.5,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 7.1,
    transform: "matrix(0.4977 -0.8673 0.8673 0.4977 4.1874 49.922)",
    width: 1.2,
    height: 28.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,30H28.8V0H59V30z M30,28.8h27.8V1.2H30V28.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,25.9H32.3V3.7H55V25.9z M33.4,24.8h20.5v-20H33.4V24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAk15543430);
export default __webpack_public_path__ + "static/media/AK1_5_54343_0.26b3030185c063914a94210c2ee5e0c6.svg";
export { ForwardRef as ReactComponent };